/* eslint no-magic-numbers: "off" */
require('spectrum-colorpicker');

import { COLOR_PICKERS_TO_ATTRIBUTES_MAPPING, THEMES } from '@engine/features/wpf_custom_theme/dependent_fields_mapping';
var storedTheme = {};
var currentScale = 0.7;
var MIN_SCALE = 0.5;
var MAX_SCALE = 1.5;

function removeBackdrop() {
  $('.backdrop').remove();
  $('.wpf-loader').remove();
}

function colorpickersIterator(callback) {
  Object.keys(COLOR_PICKERS_TO_ATTRIBUTES_MAPPING).forEach(function (colorpickerId) {
    var color = $('#' + colorpickerId).val();
    callback(colorpickerId, color);
  });
}

function getColorpickersValues() {
  var colors = {};
  colorpickersIterator(function (colorpickerId, color) {
    colors[colorpickerId] = color;
  });
  return colors;
}

function getBaseThemeName() {
  return $('.themes input.dark').is(':checked') ? 'dark' : 'light';
}

function cacheMerchantThemePreferences() {
  storedTheme = {
    colors: getColorpickersValues(),
    baseTheme: getBaseThemeName()
  };
}

function getIframeHtml() {
  return $('iframe#static-wpf-frame').contents().find('html');
}

function updateColorpickerRelatedElementsColors(colorpickerId, color) {
  var cssPropertiesForElementSelectors = COLOR_PICKERS_TO_ATTRIBUTES_MAPPING[colorpickerId];
  Object.keys(cssPropertiesForElementSelectors).forEach(function (elementId) {
    getIframeHtml().parent().find(elementId).css(cssPropertiesForElementSelectors[elementId], color);
  });
}

function updateStaticThemeImages(theme) {
  var action = theme === 'dark' ? 'removeClass' : 'addClass';
  getIframeHtml().find('.language-selector-wrapper .selected')[action]('dark');
  getIframeHtml().find('.security-hint')[action]('dark');
}

function updateStaticThemeElementsColors() {
  colorpickersIterator(function (colorpickerId, color) {
    updateColorpickerRelatedElementsColors(colorpickerId, color);
  });
}

function updateColorpickers(theme) {
  Object.keys(THEMES[theme]).forEach(function (colorpickerId) {
    $('#' + colorpickerId + '.color-picker').spectrum('set', THEMES[theme][colorpickerId]);
  });
}

function calculateScale(scaleStep) {
  var newScale = currentScale + scaleStep;

  if (newScale < MIN_SCALE || newScale > MAX_SCALE) {
    return currentScale;
  }

  currentScale = newScale;
  return newScale;
}

function initializeColorpickers() {
  $('.color-picker').spectrum({
    preferredFormat: 'hex',
    showInput: true,
    showInitial: true,
    showPalette: true,
    palette: [['white'], ['#94a545'], ['#1588f1'], ['#E71278']],
    move: function move(color) {
      updateColorpickerRelatedElementsColors(this.id, color.toRgbString());
    },
    hide: function hide(color) {
      updateColorpickerRelatedElementsColors(this.id, color.toRgbString());
    }
  });
}

function listenForThemeChange() {
  $('.themes input[type=radio]').on('change', function () {
    var theme = this.value;
    updateStaticThemeImages(theme);
    updateColorpickers(theme);
    updateStaticThemeElementsColors();
  });
}

function listenForResetButton() {
  $('#reset').on('click', function () {
    Object.keys(storedTheme.colors).forEach(function (colorpickerId) {
      var color = storedTheme.colors[colorpickerId];
      updateColorpickerRelatedElementsColors(colorpickerId, color);
      $('#' + colorpickerId + '.color-picker').spectrum('set', color);
    });
    $('.themes input.' + storedTheme.baseTheme).prop('checked', true);
  });
}

function listenForScale() {
  $('#scale button').on('click', function () {
    var scaleStep = $(this).data('scale');
    getIframeHtml().css('transform', 'scale(' + calculateScale(scaleStep) + ')');
  });
}

function onIframeLoad() {
  updateStaticThemeElementsColors();
  updateStaticThemeImages(storedTheme.baseTheme);
  removeBackdrop();
  $('.alert').fadeOut(7000);
}

function initialSetup() {
  initializeColorpickers();
  cacheMerchantThemePreferences();
  listenForThemeChange();
  listenForResetButton();
  listenForScale();
}

var WpfCustomTheme = {
  initialSetup: initialSetup,
  onIframeLoad: onIframeLoad
};
export default WpfCustomTheme;